import { Box, Button } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';
import { RiArchiveStackLine } from 'react-icons/ri';

import DashboardCard from './DashboardCard';
import userLookupStyle from './userLookup.module.css';
import { useStoreActions } from '../../reducers';

export default function RecordingLookUpSearch() {
  const [driveId, setDriveId] = useState<number | undefined>(undefined);

  const { getRecordingInfoById, clearRecordingLookup } = useStoreActions(
    (actions) => actions.adminDashboard
  );

  useEffect(() => {
    if (driveId === undefined) {
      clearRecordingLookup();
    }
  }, [driveId, clearRecordingLookup]);

  const handleSearch = async () => {
    if (driveId) {
      try {
        await getRecordingInfoById(driveId);
      } catch (error) {
        console.error('Search failed:', error);
      }
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const searchContent = (
    <Box
      display="flex"
      gap={2}
      alignItems="center"
      mt={3}
      data-testid="recording-lookup-search-box"
    >
      <input
        placeholder="Enter drive ID"
        value={driveId}
        onChange={(e) =>
          setDriveId(e.target.value === '' ? undefined : Number(e.target.value))
        }
        onKeyDown={handleKeyPress}
        type="number"
        className={userLookupStyle.inputField}
        data-testid="recording-lookup-search-input"
      />
      <Button
        variant="outline"
        onClick={handleSearch}
        isDisabled={!driveId}
        data-testid="recording-lookup-search-btn"
      >
        Search
      </Button>
    </Box>
  );

  return (
    <DashboardCard
      icon={<RiArchiveStackLine size={18} />}
      title="Search Recording"
      description="Enter a drive ID to search for recording information"
      data-testid="recording-lookup-search-card"
      style={{ alignContent: 'start' }}
    >
      {searchContent}
    </DashboardCard>
  );
}
